import { IJob, ILocation } from 'wisestep-api';

import google_logo from '../../../images/Google_logo.png';
import indeed_logo from '../../../images/Indeed_logo.png';
import linkedIn_logo from '../../../images/LinkedIn_logo.png';
import twitter_logo from '../../../images/Twitter_logo.png';
import { openUrlInNewTab } from '../../../utils/openUrlInNewTab';

export const socialSearchOptions = [
  {
    label: 'LinkedIn',
    image: linkedIn_logo,
  },
  {
    label: 'Indeed',
    image: indeed_logo,
  },
  {
    label: 'Google (Direct)',
    image: google_logo,
  },
  {
    label: 'Google (LinkedIn)',
    image: google_logo,
  },
  {
    label: 'X (formerly Twitter)',
    image: twitter_logo,
  },
];

export const getLocationForSearch = (location: ILocation): string => {
  const { city, state, country, continent } = location;

  const locationParam = [city, state, country].filter(Boolean);

  return locationParam.length > 0 ? locationParam.join(',') : continent ?? '';
};
export const handleSharingOfJobsAcrossPlatforms = (
  sharingOfJobsPlatform: string,
  job: IJob,
  socialSearchBooleanString: string
) => {
  const booleanstring = job?.boolQueryFocused ?? socialSearchBooleanString;
  switch (sharingOfJobsPlatform) {
    case 'Google (Direct)':
      openUrlInNewTab(
        'https://www.google.com/search?q=filetype:(pdf OR doc OR docx OR rtf)  ("' +
          getLocationForSearch(job?.locations?.length ? job.locations?.[0] : ({} as ILocation)) +
          '") (resume OR cv) -job -sample  ' +
          booleanstring
      );
      break;
    case 'Google (LinkedIn)':
      openUrlInNewTab(
        'https://www.google.com/search?q=site:linkedin.com/in ("' +
          getLocationForSearch(job?.locations?.length ? job.locations?.[0] : ({} as ILocation)) +
          '") ' +
          booleanstring.replaceAll(/[()]/gm, '')
      );
      break;
    case 'LinkedIn':
      openUrlInNewTab('https://www.linkedin.com/search/results/people/?keywords=' + booleanstring);
      break;
    case 'Indeed':
      openUrlInNewTab(
        'https://resumes.indeed.com/search?l=' +
          getLocationForSearch(job?.locations?.length ? job.locations?.[0] : ({} as ILocation)) +
          '&q=' +
          booleanstring
      );
      break;
    case 'X (formerly Twitter)':
      openUrlInNewTab(
        'https://twitter.com/search?f=user&q=near:"' +
          getLocationForSearch(job?.locations?.length ? job.locations?.[0] : ({} as ILocation)) +
          '" within:100mi ' +
          job.title
      );
      break;
  }
};
